<template>
  <div>
    <div class="sep-top-xs sep-bottom-xs">
      <div class="input-group">
        <span class="input-group-addon">
          <strong>Vendor Search:</strong>
        </span>
        <input
          id="var_search"
          v-model="var_search"
          type="text"
          name="var_search"
          class="form-control"
          value
          @keyup.prevent="searchVendor"
        />
      </div>
    </div>
    <table
      v-if="vendorsResults.length > 0"
      class="table table-striped text-left"
    >
      <thead>
        <tr>
          <th>Select</th>
          <th>Company</th>
        </tr>
      </thead>
      <tbody class="varListTable">
        <tr v-for="vendor in vendorsResults" :key="`vendor-${vendor.slug}`">
          <td>
            <input
              type="radio"
              name="var_referral"
              required="required"
              @change.prevent="check(vendor.slug)"
            />
          </td>
          <td>{{ vendor.name }} - ({{ vendor.slug }})</td>
        </tr>
      </tbody>
    </table>
    <div v-if="vendorStatus == 'empty'">No records found.</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      var_search: "",
      checked_vendor: this.checked_vendor,
      vendor_results: "",
    };
  },
  computed: {
    vendorsResults() {
      return this.$store.state.registration.vendor_results;
    },
    vendorStatus() {
      return this.$store.state.registration.vendor_status;
    },
    loading() {
      return this.$store.state.registration.loading;
    },
  },
  methods: {
    searchVendor(event) {
      const criteria = event.target.value;
      if (criteria.length > 2) {
        this.$store.dispatch("setCheckedVarReseller", null);
        this.$store.dispatch("searchVendor", criteria);
      }
    },
    check(slug) {
      this.$store.dispatch("setCheckedVarReseller", slug);
    },
  },
};
</script>
